/* globals process */

import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";

import { history } from "../../_helpers";
import { alertActions } from "../../_actions";
import { PrivateRoute } from "../PrivateRoute";
import ReactGA from "react-ga";
import ErrorBoundary from "../ErrorBoundary";
import DashboardPage from "../DashboardPage";
import LoginPage from "../LoginPage";
import AllNotePage from "../AllNotePage";
import AllAlertPage from "../AllAlertPage";
import AllSensorPage from "../AllSensorPage";
import ViewDevicePage from "../ViewDevicePage";
import ViewNote from "../ViewNote";
import NotFoundPage from "../NotFoundPage";
import AllReportPage from "../AllReportPage";
import AlertModal from "../AlertModal";
import AllSensorMap from "../AllSensorMap";
import NoteResolvePage from "../NoteResolvePage";
import NoteRetractResolvePage from "../NoteRetractResolvePage";
import NoteSignoffPage from "../NoteSignoffPage";
import NoteRetractSignoffPage from "../NoteRetractSignoffPage";
import NoteRefuseSignoffPage from "../NoteRefuseSignoffPage";
import NoteAssignUserPage from "../NoteAssignUserPage";
import NoteSingleMergePage from "../NoteSingleMergePage";
import CustomReportPage from "../CustomReportPage";
import SensorDataReportPage from "../SensorDataReportPage";
import ObservationPage from "../ObservationPage";

import "./index.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fixedHeader: false
    };
    const { dispatch } = this.props;
    history.listen(() => {
      //Trigger page views for google analytics
      ReactGA.pageview(window.location.pathname + window.location.search);
      // clear alert on location change
      dispatch(alertActions.clear());
    });
  }

  componentDidMount() {
    //initializing Google analytics
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_SECRET, {
      debug: true,
      titleCase: false,
      gaOptions: {
        userId: 123,
        cookieDomain: "none"
      }
    });
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    if (document.documentElement.scrollTop > 58) {
      if (this.state.fixedHeader === false) {
        this.setState(() => {
          return {
            fixedHeader: true
          };
        });
      }
    } else {
      if (this.state.fixedHeader === true) {
        this.setState(() => {
          return {
            fixedHeader: false
          };
        });
      }
    }
  };

  render() {
    return (
      <ErrorBoundary>
        <div className={"rootPanel " + (this.state.fixedHeader ? "header-fixed" : "")}>
          <Router history={history}>
            <div>
              <Switch>
                <Route path="/login" component={LoginPage} />
                <PrivateRoute exact path="/" component={DashboardPage} />
                <PrivateRoute path="/alerts" component={AllAlertPage} />
                <PrivateRoute path="/notes" component={AllNotePage} />
                <PrivateRoute path="/devices" component={AllSensorPage} />
                <PrivateRoute path="/devicesMap" component={AllSensorMap} />
                <PrivateRoute path="/reports" component={AllReportPage} />
                <PrivateRoute path="/note/:noteID/view" component={ViewNote} />
                <PrivateRoute path="/note/:noteID/resolve" component={NoteResolvePage} />
                <PrivateRoute path="/note/:noteID/retract_resolve" component={NoteRetractResolvePage} />
                <PrivateRoute path="/note/:noteID/sign_off" component={NoteSignoffPage} />
                <PrivateRoute path="/note/:noteID/refuse_signoff" component={NoteRefuseSignoffPage} />
                <PrivateRoute path="/note/:noteID/retract_signoff" component={NoteRetractSignoffPage} />
                <PrivateRoute path="/note/:noteID/assign_owner" component={NoteAssignUserPage} />
                <PrivateRoute path="/note/:noteID/merge" component={NoteSingleMergePage} />
                <PrivateRoute path="/device/:deviceId/telemetry" component={ViewDevicePage} />
                <PrivateRoute path="/device/:deviceId" component={ViewDevicePage} />
                <PrivateRoute path="/createCustomReport" component={CustomReportPage} />
                <PrivateRoute path="/createSensorReport" component={SensorDataReportPage} />
                <PrivateRoute path="/createObservation" component={ObservationPage} />
                <Route component={NotFoundPage} />
              </Switch>
              <AlertModal />
            </div>
          </Router>
        </div>
      </ErrorBoundary>
    );
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert
  };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/_components/App/index.js